import { useCallback, useEffect, useState } from 'react'
import * as Sentry from '@sentry/react'
import type { BoxTruckMapDriver } from '../services/boxTruckLoadsApi'
import { fetchBoxTruckMapDrivers } from '../services/boxTruckMapApi'

export const useBoxTruckMap = () => {
    const [drivers, setDrivers] = useState<BoxTruckMapDriver[]>([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState<string | null>(null)

    const refresh = useCallback(async () => {
        setLoading(true)
        setError(null)
        try {
            setDrivers(await fetchBoxTruckMapDrivers())
        } catch (cause) {
            Sentry.captureException(cause, { tags: { feature: 'box-truck-map', operation: 'load-drivers' } })
            setError('Map drivers are temporarily unavailable. Please try again.')
        } finally {
            setLoading(false)
        }
    }, [])

    useEffect(() => {
        void refresh()
    }, [refresh])

    return { drivers, loading, error, refresh }
}
